export default "__VITE_ASSET__$KkE$ndL__"